import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LiveMealFilterEntity } from '../../domain/entities/LiveMealFilterEntity'
import type { MealStatus } from '@/features/meal/domain/enums/MealStatus'

export class LiveMealFilterModel extends LiveMealFilterEntity {
  regionIds!: Array<number>
  declare statuses: Array<MealStatus>

  constructor(dataDto: LiveMealFilterEntity) {
    super()
    mapEntityProperties<LiveMealFilterModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id)
      }
    })
  }
}
